import React from "react";
import { useFilters } from "hooks/useStore";

const ClearAllFilters = ({ handle }) => {
	const { clearAllFilters, collections } = useFilters(["clearAllFilters", "collections"]);
	const { totalActiveFilters } = handle in collections ? collections[handle] : {};

	if (!totalActiveFilters) return <div className="lg:min-h-36 collection-v1" />;

	return (
		<button onClick={() => clearAllFilters(handle)}
			className="font-bold border-b border-black lg:min-h-6 lg:my-3 lg:pt-24 clear-filters-v-2">
			<span className="pr-2">X</span>CLEAR ALL FILTERS ({totalActiveFilters})
		</button>
	);
};

export default ClearAllFilters;